// extracted by mini-css-extract-plugin
export default {"contact":"SectionContact_contact__-verH","info":"SectionContact_info__TlsKk","block":"SectionContact_block__GFy-b","adress":"SectionContact_adress__JEkZi"};